<div class="loading-spinner-center">
  <img src="assets/loading_symbol.gif" alt="laddar logo">
</div>
